import { useState } from 'react'
import { MobileTitle } from '../components/Title'
import ReactPlayer from 'react-player'
import { FullScreenModal } from '../utility/FullScreenModal'
export const Media = () => {
    const [isPlaying, setIsPlaying] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', url: '', index: 0 })
    const handleOpenModal = (contentType, category, url, index, maxIndex) => {
        setModalContent({ contentType, category, url, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            <div className='py-12 w-full text-center mx-auto'>
                <span className=' relative pt-2'>
                    <h1 className='md:hidden text-gradient-title text-xlg font-pop inline-block'>Media</h1>{' '}
                </span>
            </div>
            <div className='px-4 max-w-[800px] flex flex-col justify-center mx-auto gap-16 my-20'>
                <div className='w-full text-center'>
                    <span className='relative inline-block '>
                        {' '}
                        <h1 className='text-center text-gradient-title text-base md:text-base lg:text-lg font-pop my-4'>
                            Tokyo Game Show 2024 Event
                        </h1>{' '}
                    </span>
                    <div className='video-thumb w-full text-center'>
                        <img
                            onClick={() => {
                                handleOpenModal('video', 'home', 'https://www.youtube.com/watch?v=_0ozVFev9a4', 1)
                                console.log()
                            }}
                            className='ss-thumb'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/tgs-thumb.webp`}
                        />{' '}
                    </div>{' '}
                </div>
                <div className='w-full text-center'>
                    
                        <h1 className='text-center text-gradient-title text-base md:text-base lg:text-lg font-pop my-4'>
                            Release Date Announcement Trailer
                        </h1>{' '}
                  
                    <div className='video-thumb w-full text-center'>
                        <img
                            onClick={() => {
                                handleOpenModal('video', 'home', 'https://youtu.be/QjK3RZBxWrA', 1)
                                console.log()
                            }}
                            className='ss-thumb'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/pv2-thumb.webp`}
                        />{' '}
                    </div>{' '}
                </div>
                <div className=''>
                    <h1 className='text-center text-gradient-title text-base md:text-base lg:text-lg font-pop my-4'>
                        Nintendo Direct 2024.6.18
                    </h1>{' '}
                    <div className='video-thumb'>
                        <img
                            onClick={() => {
                                handleOpenModal('video', 'home', 'https://www.youtube.com/watch?v=nuR3rUklk_I', 1)
                                console.log()
                            }}
                            className='ss-thumb video-thumb'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/NinDi.webp`}
                        />{' '}
                    </div>{' '}
                </div>{' '}
                <div className=''>
                    <h1 className='text-center text-gradient-title text-base md:text-base lg:text-lg font-pop my-4'>
                        Announcement Trailer
                    </h1>{' '}
                    <div className='video-thumb'>
                        <img
                            onClick={() => {
                                handleOpenModal('video', 'home', 'https://youtu.be/e1dBBpjc34I', 1)
                                console.log()
                            }}
                            className='ss-thumb video-thumb'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/pv1-thumb.webp`}
                        />{' '}
                    </div>{' '}
                </div>{' '}
                <FullScreenModal
                    showModal={showModal}
                    modalContent={modalContent}
                    setModalImage
                    handleCloseModal={handleCloseModal}
                    setModalContent={setModalContent}
                    maxIndex={1}
                />
            </div>
        </>
    )
}
